<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span><router-link to="/contacts/list_contacts" class="text-white pl-2 text-line">Contacts</router-link></span>
                    <a>View Contact</a>
                </div>
                <div class="text-right" v-if="(userPermissions.contacts_business.permitted_actions.edit || userPermissions.contacts_personal.permitted_actions.edit) && active_tab == 'contact_info' && selectedTab != 'Archive'">
                    <button  class="btn btn-des-small mt-2 ml-6 new-field-btn d-block ml-auto mb-3 mr-4" :disabled="loggedInUser.user_role == 'sales_person' && contact_type == 'business'" @click="editContact()">Edit</button>
                </div>
            </div>
            <!-- <div class="d-flex" v-if="selectedTab != 'Personal'">
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'contact_info','new-blue':active_tab == 'contact_info'}" @click="switchTabs('contact_info')">
                    <span class="text-capitalize">Contact Info</span>
                </div>
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'interaction','new-blue':active_tab == 'interaction'}" @click="switchTabs('interaction')">
                    <span class="text-capitalize">Interaction</span>
                </div>
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'activity_log','new-blue':active_tab == 'activity_log'}" @click="switchTabs('activity_log')">
                    <span class="text-capitalize">Activity Log</span>
                </div>
            </div> -->
            <!-- Tabs Section -->
            <div class="tabs tabs-style-shape" v-if="selectedTab != 'Personal'">
                <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                    </defs>
                </svg>
                <nav>
                    <ul class="ml-0">
                        <li :class="{'tab-current':active_tab == 'contact_info'}">
                            <a href="javascript:;" @click="switchTabs('contact_info')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span>Contact Info</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'interaction'}">
                            <a href="javascript:;" @click="switchTabs('interaction')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Interaction</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'activity_log'}">
                            <a href="javascript:;" @click="switchTabs('activity_log')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Activity Log</span>
                            </a>
                        </li>
                        <!-- For styling we need this tag  -->
                        <li style="width: 0px !important;flex: 0 !important;">
                            <a href="#section-shape-3" style="margin: 0">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <contact-info v-if="contact_info"></contact-info>
            <contact-interaction v-if="interaction"></contact-interaction>
            <activity-log v-if="activity_log"></activity-log>
        </div>
    </div>
</template>

<script>
const ContactInfo = () => import('./ContactInfo')
const ContactInteraction = () => import('./ContactInteraction')
const ActivityLog = () => import('./ActivityLog')
import { HalfCircleSpinner } from "epic-spinners";
import contacts from "../mixins/contacts.js";
export default {
    data() {
        return {
            ajaxCallInProgress: false,
            show_basic_info: true,
            contact_tab: true,
            referral_info: true,
            //contact_details: null,
            contact_type:'',
            active_tab: 'contact_info',
            contact_info: true,
            interaction: false,
            activity_log: false,
            selectedTab: '',
        }
    },
    mixins:[contacts],
    methods: {
        //swtich the tabs between contact info/interaction/activitylog
        /**@params = obj */
        switchTabs (obj){
            if(obj == 'contact_info'){
                this.active_tab = 'contact_info'
                this.contact_info = true
                this.interaction = false
                this.activity_log = false
            }
            else if(obj == 'interaction'){
                this.active_tab = 'interaction'
                this.contact_info = false
                this.interaction = true
                this.activity_log = false
            }
            else if(obj == 'activity_log'){
                this.active_tab = 'activity_log'
                this.contact_info = false
                this.interaction = false
                this.activity_log = true
            }
        },
        //show the basic information tab
        showBasicInformation() {
            this.show_basic_info = !this.show_basic_info
        },
        //show the contact
        showContact() {
            this.contact_tab = !this.contact_tab
        },
        //show the referrals
        showReferrals() {
            this.referral_info = !this.referral_info
        },
        //Api calls to load the contact details
        // async loadContactDetails(){
        //     let type = localStorage.getItem("contact_type")
        //     if(type == 'business'){
        //         this.ajaxCallInProgress = true
        //         let response = await this.getBusinessContactDetails(this.$route.params.id)
        //         this.contact_details = response.response
        //         this.ajaxCallInProgress = false
        //     }
        //     else{
        //         this.ajaxCallInProgress = true
        //         let response = await this.getPersonalContactDetails(this.$route.params.id)
        //         this.contact_details = response.response
        //         this.ajaxCallInProgress = false
        //     }
        // },
        //redirecting to the edit contact 
        editContact(){ 
            let id = this.$route.params.id
            this.$router.push('/edit_contact/' + id)
        }
    },
    components:{
        HalfCircleSpinner,
        ContactInfo,
        ContactInteraction,
        ActivityLog
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
    mounted() {
        this.selectedTab = localStorage.getItem('TabContactsActive')
        //this.loadContactDetails()
        this.contact_type = localStorage.getItem("contact_type")
    }
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .inner-div {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 40px;
        padding-right: 40px;
    }
    .tab-paddding{
        padding-right :32px;
    }
    .primary-tag {
        border-radius: 10px;
        font-size: 10px;
        font-weight: 500;
        padding: 2px 10px;
        color: #fff;
        height: max-content;
    }
    .social-media {
        background: #def0f9;
        border-radius: 5px;
        width: 10em;
        height: 10em;
        margin-right: 25px;
        margin-bottom: 30px;
    }
    .add-vendor{
        color: rgba(103, 103, 103, 0.84);
        position: inherit;
        background: #ffffff;
        width: 100%;
        height: 34px;
        line-height: 32px;
        padding-left: 18px;
        z-index: 9999;
        cursor: pointer;
        top: 84%;
        border: solid 1px #cdd2da;
    }
    .new-field-btn{
        color: #fff !important;
        background-color: #00448b !important;
    }
    .new-field-btn:disabled{
        background-color: #ccc !important;
    }
    .remainder-list{
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px;
        height:100px
    }
    .new-contactView-item {
        padding: 16px 10px 16px 3px !important;
    }

    .new-contactView {
        display: flex;
        align-items: center;
    }

   .input-field-underline {
		border: none !important;
        border-bottom: solid 0.5px #cdd2da !important;
        background-color: #fff;
        padding: 8px 10px;
        width: 100%;
		/* height: 38px; */
    }
    .view-contact-tab {
        margin-left: 14px!important;
        padding :10px 20px 10px 20px;
    }
    .social-media-edit{
        background: #def0f9;
        border-radius: 5px;
        width: 6em;
        height: 6em;
        margin-right: 25px;
    }
    .social-media-icons{
      width: 1.5em;
      height: 1.5em;
    }
    .address-card-height {
        overflow-y: scroll;
        overflow-x: scroll;
        max-height: 200px;
    }
    .bord-custom{
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacts/ViewContact.vue